<template>
  <div>
    <div class="page-content">
      <div class="agree-wrapper" v-show="mxIsContract == 2 || mxIsContract < 0">
        <el-row>
          <el-col :span="24">
            <div class="agree-header">
              <i class="el-icon-warning"></i>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="agree-title" v-show="mxIsContract < 0">
              该公司未绑定合同，请上传合同文件
            </div>
            <div class="agree-title" v-show="mxIsContract == 2">
              合同审核拒绝，请重新上传
            </div>
          </el-col>
        </el-row>
      </div>
      <el-row
        class="contact-upload"
        v-show="mxIsContract == 2 || mxIsContract < 0"
      >
        <el-form
          ref="contractForm"
          :model="formData"
          :rules="rules"
          label-width="100px"
        >
          <el-col :span="24" class="content-left">
            <el-form-item label="上传文件" prop="file_url">
              <upload-file
                @remove_file="handleRemoveFile"
                @return_url="handUploadFile"
                :title="title"
                :multiple="'false'"
                :multiSelection="false"
                :dir="'bill'"
                :selectfiles="'importExcel'"
                :postfiles="'submitImportExcel'"
                :ossfile="'ossExcelFile'"
                ref="uploadImg"
                :max_width="1000"
                :max_height="1000"
              />
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div
        class="warn-title"
        v-show="mxIsContract == 0"
        style="margin-top: 120px"
      >
        合同审核中，请稍后再试或联系管理员尽快审核
      </div>
      <div class="mod-index" v-show="mxIsContract == 1">
        <el-row class="header-wrapper">
          <el-form
            :inline="true"
            style="display: flex; justify-content: space-between"
          >
            <el-form-item label="当前税源地：">
              <el-select
                v-model="channel_account"
                placeholder="请选择税源地"
                @change="channelChange"
				clearable
                filterable
              >
                <el-option
                  v-for="item in channelList"
                  :key="item.channel_account"
                  :label="item.channel_name"
                  :value="item.channel_account"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="display: flex; justify-content: flex-end">
              <HomeDatePicker @dataSearch="dataSearch" />
            </el-form-item>
          </el-form>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="info">
                <div class="info-title">充值金额</div>
                <div class="info-price">{{ rechargeMoney }}</div>
              </div>
              <img :src="recharge" class="info-img" />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="info">
                <div class="info-title">下发金额</div>
                <div class="info-price">{{ money }}</div>
              </div>
              <img :src="price" class="info-img" />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="info">
                <div class="info-title">服务费</div>
                <div class="info-price">{{ taxMoney }}</div>
              </div>
              <img :src="taxation" class="info-img" />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="info">
                <div class="info-title">退款金额</div>
                <div class="info-price">{{ refund_money }}</div>
              </div>
              <img :src="price" class="info-img" />
            </div>
          </el-col>
		<el-col :span="6" v-if="isLaowu">
		<div class="grid-content bg-purple" style="margin-top: 20px;">
		<div class="info">
		<div class="info-title">税费</div>
		<div class="info-price">{{ labor_dispatch_money }}</div>
		</div>
		<img :src="price" class="info-img" />
		</div>
		</el-col>
        </el-row>
        <el-row class="home-main">
          <div :style="{
              width: '63%',
              height: '500px',
              padding: '20px',
              marginTop: '20px',
              borderRadius: '25px',
              boxShadow:
                '0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)',
            }" v-if="this.$store.state.userPermissions.includes('necessary_statistics')">
				<div :style="{height:'100px'}" v-if="is_ysy">
					<div :style="{height:'25px','font-size':'16px','font-weight':'600','color':'#000000'}">交易金额趋势图</div>
					<div :style="{height:'25px','font-size':'14px','font-weight':'600','margin-left':'20px'}">风险预警</div>
					<div :style="{height:'25px','font-size':'14px','font-weight':'600','margin-left':'20px'}">个人交易大于300万 <span @click="toWarnList(300)">共<span :style="{color:'red'}">{{warn_300_num}}</span>位</span></div>
					<div :style="{height:'25px','font-size':'14px','font-weight':'600','margin-left':'20px'}">个人交易大于500万 <span @click="toWarnList(500)">共<span :style="{color:'red'}">{{warn_500_num}}</span>位</span></div>
				</div>
				<div :id="is_ysy?'chartmain1':'chartmain'" :style="{height:is_ysy?'360px':'500px','margin-top':'20px'}"></div>
			</div>
			<div :style="{
				width: '63%',
				height: '500px',
				padding: '20px',
				marginTop: '20px',
				borderRadius: '25px',
				boxShadow:'0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)',
				}" v-else>
				<div :style="{height:'100px'}" v-if="is_ysy">
					<div :style="{height:'25px','font-size':'16px','font-weight':'600','color':'#000000'}">交易金额趋势图</div>
					<div :style="{height:'25px','font-size':'14px','font-weight':'600','margin-left':'20px'}">风险预警</div>
					<div :style="{height:'25px','font-size':'14px','font-weight':'600','margin-left':'20px'}">个人交易大于300万 <span @click="toWarnList(300)">共<span :style="{color:'red'}">{{warn_300_num}}</span>位</span></div>
					<div :style="{height:'25px','font-size':'14px','font-weight':'600','margin-left':'20px'}">个人交易大于500万 <span @click="toWarnList(500)">共<span :style="{color:'red'}">{{warn_500_num}}</span>位</span></div>
				</div>
				<div :id="is_ysy?'chartmain1':'chartmain'" :style="{height:is_ysy?'360px':'500px','margin-top':'20px'}"></div>
			</div>
          <!-- 预处理项目 -->
          <div class="Yuchzhi" v-if="this.$store.state.userPermissions.includes('necessary_statistics')">
            <h1 class="Yuchzhi-title">预充值项目</h1>
            <div class="Yuchzhi-content">
              <div>消费金额：</div>
              <div class="usemoney">
                ￥{{ usemoney ? `${usemoney}` : "0.00" }}
              </div>
            </div>
            <div class="Yuchzhi-bottom">
              <div class="">使用情况：</div>
              <div v-for="(item, index) in record" :key="index" class="record">
                <span class="record-title">{{ item.title }}:</span>
                <span class="record-money">{{ item.money }}元</span><i></i>
                <span class="record-number">{{ item.number }}条</span>
              </div>
            </div>
          </div>
        </el-row>
      </div>
    </div>
    <!-- 系统公告模态框 -->
    <NoticeDialog
      :dialogVisible="dialogVisible"
      :htmlData="htmlData"
      @know="know"
      @handleClose="handleClose"
    />
	<!-- 预警记录 -->
	<ModalDialog :dialogData="dialogDataWarn" @dialogClose="dialogClose" :showButton="['determine']">
		<template slot="content">
			<ApeTable ref="apeTable" :data="companyList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" highlight-current-row >
			</ApeTable>
		</template>
	</ModalDialog>
  </div>
</template>
<script>
import price from "../../../public/img/moneyBill.svg";
import recharge from "../../../public/img/yenSign.svg";
import taxation from "../../../public/img/checkSquare.svg";
import UploadFile from "@/components/UploadFile";
import NoticeDialog from "@/components/NoticeDialog";
import HomeDatePicker from "@/components/HomeDatePicker";
import ModalDialog from '@/components/ModalDialog'
import ApeTable from '@/components/ApeTable'
export default {
  components: {
    UploadFile,
    NoticeDialog,
    HomeDatePicker,
	ModalDialog,
	ApeTable,
  },
  data() {
    return {
	is_supervision:false,
      labor_dispatch_money:"0.00",
      isLaowu:false,
      channelList: [],
      channel_account: "",
      price: price,
      recharge: recharge,
      taxation: taxation,
      htmlData: "",
      dialogVisible: false,
      pages: [],
      title: "合同",
      dialogData: {
        visible: true,
        title: "客户管家系统升级公告",
        width: "45%",
        loading: true,
        modal: false,
      },
      rules: {},
      formData: {
        file_url: "",
        status: 0,
      },
      rechargeMoney: "0.00",
      money: "0.00",
      refund_money:'0.00',
      taxMoney: "0.00",
      list: [
        {
          title: "充值金额",
          value: "0.00",
          imgUrl: recharge,
        },
        {
          title: "下发金额",
          value: "0.00",
          icon: "警告",
          imgUrl: price,
        },
        {
          title: "服务费",
          value: "0.00",
          imgUrl: taxation,
        },
      ],
      inputPrice: "",
      rechargePrice: "0.00",
      servicePrice: "0.00",
      taxratePrice: "0.00",
      taxrate: "",
      // accountName: "",
      paymentAccount: "",
      accountBank: "",
      bankOfDeposit: "浙江网商银行",
      id: "",
      localStroageId: "",
      searchCondition: {},
      companyId: "",
      data1: [],
      data2: [],
      start_time: "",
      end_time: "",

      // 预充值记录
      record: [],
      // 消费金额
      usemoney: "",
		is_ysy:false,
		warn_300_num:0,
		warn_500_num:0,
		dialogDataWarn:{
			visible: false,
			title: '',
			width: '50%',
			loading: true,
			modal: false
		},
		loadingStaus: true,
		columns: [
			{
				title: '姓名',
				value: 'name',
				header_align: 'center',
				align: 'center',
			},
			{
				title: '身份证号',
				value: 'id_number',
				header_align: 'center',
				align: 'center',
			},
			{
				title: '应付酬劳',
				value: 'send_money',
				header_align: 'center',
				align: 'center',
			}
		],
		// 表格列表数据
		companyList:[],
		// 分页信息
		pagingData:{
			is_show: true,
			layout: 'total, sizes, prev, pager, next, jumper',
			total: 0
		},
		count_data:[],
		list_data:[]
    };
  },
  watch: {
    id(val) {
      if (this.pages.includes("index")) {
        if (val != this.localStroageId) {
          setTimeout(() => {
            this.dialogVisible = true;
          }, 500);
        } else {
          this.dialogVisible = false;
        }
      } else {
        this.dialogVisible = false;
      }
    },
  },
  filters: {
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return Y + M + D;
    },
  },
  methods: {
    setThousandsMark(num){
      if(num) {
        const formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',      // 格式化成十进制数字
        minimumFractionDigits: 2,  // 最少保留 2 位小数
        maximumFractionDigits: 2   // 最多保留 2 位小数
      })
      const res = formatter.format(num)
      return res
      }
       return num
    },
	async queryRole(){
		let userinfo = await this.$api.getUserDetail();
		this.is_supervision=userinfo?.roles?.includes('supervision')||false
		if(!this.is_supervision){
			localStorage.setItem('home_channel_account','')
			this.channel_account=''
		}else{
			this.channel_account=localStorage.getItem('home_channel_account')
		}
		console.log(userinfo.roles,'queryRole')
	},
    channelChange() {
      let args = {
        start_time: this.start_time,
        end_time: this.end_time,
        channel_account: this.channel_account,
      }
	if(this.is_supervision){
		localStorage.setItem('home_channel_account',this.channel_account)
	}
     
      this.getRecharge(args);
      this.getInfo();
    },
    //获取服务公司下的税源地
    async tenantCategoryList() {
      let result = await this.$api.tenantCategoryList();
      if (result) {
        this.channelList = result;
      }
    },
    //曲线图表
    curveChart() {
      const newTime = new Date();
      const endTe = this.$options.filters["timestampToTime"];
      const today = endTe(newTime).split("-")[2];
      const data = [];
      const data1 = [];
      var lastMonthDay = this.mxMonthDay(
        endTe(newTime).split("-")[0],
        endTe(newTime).split("-")[1] - 1
      );
      const newMonth = endTe(newTime).split("-")[1];
      if (today > 7) {
        for (let i = 7; i >= 1; i--) {
          var sevenDay = today - i;
          if (sevenDay > 9) {
            data.push(
              endTe(newTime).split("-")[0] +
                "-" +
                endTe(newTime).split("-")[1] +
                "-" +
                sevenDay
            );
          } else {
            data.push(
              endTe(newTime).split("-")[0] +
                "-" +
                endTe(newTime).split("-")[1] +
                "-" +
                "0" +
                sevenDay
            );
          }
        }
      } else {
        let previousDays = 7 - today;
        let previousStart = lastMonthDay - previousDays;
        for (let i = previousStart; i <= lastMonthDay; i++) {
          if (i > 9) {
            if (newMonth == "01") {
              data.push(endTe(newTime).split("-")[0] - 1 + "-" + 12 + "-" + i);
            } else {
              let month =
                endTe(newTime).split("-")[1] - 1 < 10
                  ? "0" + (endTe(newTime).split("-")[1] - 1)
                  : endTe(newTime).split("-")[1] - 1;
              data.push(endTe(newTime).split("-")[0] + "-" + month + "-" + i);
            }
          } else {
            if (newMonth == "01") {
              data.push(
                endTe(newTime).split("-")[0] - 1 + "-" + 12 + "-" + "0" + i
              );
            } else {
              let month =
                endTe(newTime).split("-")[1] - 1 < 10
                  ? "0" + (endTe(newTime).split("-")[1] - 1)
                  : endTe(newTime).split("-")[1] - 1;
              data.push(
                endTe(newTime).split("-")[0] + "-" + month + "-" + "0" + i
              );
            }
          }
        }
        for (let j = 1; j < today; j++) {
          if (j > 9) {
            data.push(
              endTe(newTime).split("-")[0] +
                "-" +
                endTe(newTime).split("-")[1] +
                "-" +
                j
            );
          } else {
            data.push(
              endTe(newTime).split("-")[0] +
                "-" +
                endTe(newTime).split("-")[1] +
                "-" +
                "0" +
                j
            );
          }
        }
      }

      if (today > 30) {
        for (let i = 30; i >= 1; i--) {
          var thirtyDay = today - i;
          console.log(thirtyDay, "thirtyDay");
          if (thirtyDay > 9) {
            data1.push(
              endTe(newTime).split("-")[0] +
                "-" +
                endTe(newTime).split("-")[1] +
                "-" +
                thirtyDay
            );
          } else {
            data1.push(
              endTe(newTime).split("-")[0] +
                "-" +
                endTe(newTime).split("-")[1] +
                "-" +
                "0" +
                thirtyDay
            );
          }
        }
      } else {
        let previousDays = 30 - today;
        let previousStart = lastMonthDay - previousDays + 1;
        for (let i = previousStart; i <= lastMonthDay; i++) {
          if (i > 9) {
            if (newMonth == "01") {
              data1.push(endTe(newTime).split("-")[0] - 1 + "-" + 12 + "-" + i);
            } else {
              let month =
                endTe(newTime).split("-")[1] - 1 < 10
                  ? "0" + (endTe(newTime).split("-")[1] - 1)
                  : endTe(newTime).split("-")[1] - 1;
              data1.push(endTe(newTime).split("-")[0] + "-" + month + "-" + i);
            }
          } else {
            if (newMonth == "01") {
              data1.push(
                endTe(newTime).split("-")[0] - 1 + "-" + 12 + "-" + "0" + i
              );
            } else {
              let month =
                endTe(newTime).split("-")[1] - 1 < 10
                  ? "0" + (endTe(newTime).split("-")[1] - 1)
                  : endTe(newTime).split("-")[1] - 1;
              data1.push(
                endTe(newTime).split("-")[0] + "-" + month + "-" + "0" + i
              );
            }
          }
        }

        for (let j = 1; j < today; j++) {
          if (j > 9) {
            data1.push(
              endTe(newTime).split("-")[0] +
                "-" +
                endTe(newTime).split("-")[1] +
                "-" +
                j
            );
          } else {
            data1.push(
              endTe(newTime).split("-")[0] +
                "-" +
                endTe(newTime).split("-")[1] +
                "-" +
                "0" +
                j
            );
          }
        }
      }
      data.push(endTe(newTime));
      data1.push(endTe(newTime));
      var data_1 = Array.from(new Set(data));
      var data_2 = Array.from(new Set(data1));
      this.start_time = data_1[0];
      this.end_time = data_1[data_1.length - 1];
      let args1 = {
        start_time: data_1[0],
        end_time: data_1[data_1.length - 1],
        channel_account: this.channel_account,
      };
      if (!this.channel_account) {
        delete args1.channel_account;
      }
      this.getRecharge(args1, data_1, data_2);
      let args2 = {
        start_time: data_2[0],
        end_time: data_2[data_2.length - 1],
        channel_account: this.channel_account,
      };
      if (!this.channel_account) {
        delete args2.channel_account;
      }
      this.getRecharge(args2, data_1, data_2);
    },
    know(value) {
      console.log(value);
      this.dialogVisible = false;
    },
    handleClose(value) {
      console.log(value);
      this.dialogVisible = false;
    },
    async calculationPrice() {
      this.servicePrice = this.mxServicePrice(this.inputPrice, this.taxrate); //服务费
      this.rechargePrice = (
        Number(this.servicePrice) + Number(this.inputPrice)
      ).toFixed(2); //需要充值的金额
      this.taxratePrice = Number(this.inputPrice).toFixed(2); //税后费用
    },

    async getRecharge(data, data1, data2) {
      let result = await this.$api.getRecharge(data);
      var xdata = [];
      var x2data = [];
      if (result) {
        result.forEach((item) => {
          if (data1.includes(item.date)) {
            let index = data1.findIndex((value) => value == item.date);
            this.data1[index] = item.money;
            xdata.push(item.date);
          }
          if (data2.includes(item.date)) {
            let index = data2.findIndex((value) => value == item.date);
            this.data2[index] = item.money;
            x2data.push(item.date);
          }
        });
      }
      let myChart = this.$echarts.init(document.getElementById("chartmain"));
      myChart.setOption({
        title: {
          text: "充值趋势",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        legend: {
          data: ["近7天", "近30天"],
          selectedMode: "single",
          right: 50,
        },
        //数据区域缩放、滚动条
        dataZoom: [
          {
            type: "slider",
            show: true,
            xAxisIndex: [0],
            start: 1,
            end: 130,
          },
          {
            type: "inside",
            xAxisIndex: [0],
            start: 1,
            end: 130,
          },
        ],
        xAxis: {
          data: xdata,
        },
        yAxis: {},
        series: [
          {
            name: "近7天",
            type: "line",
            data: this.data1,
          },
          {
            name: "近30天",
            type: "line",
            data: this.data2,
          },
        ],
      });
      myChart.on("legendselectchanged", function (obj) {
        var name = obj.name;
        var option = myChart.getOption();
        if (name == "近7天") {
          option.xAxis[0].data = xdata;
          this.start_time = xdata[0];
          this.end_time = xdata[xdata.length - 1];
        } else if (name == "近30天") {
          option.xAxis[0].data = x2data;
          this.start_time = x2data[0];
          this.end_time = x2data[x2data.length - 1];
        }
        myChart.setOption(option, true);
      });
    },
    async getInfo() {
      let searchCondition = this.handleSearchCondition();
      let args = {
        channel_account: this.channel_account,
      };
      if (!this.channel_account) {
        delete args.channel_account;
      }
      Object.assign(searchCondition, args);
      let result = await this.$api.getPrice(searchCondition);

      if (result) {
        this.rechargeMoney = this.setThousandsMark(result.recharge_money);
        this.money = this.setThousandsMark(result.send_money);
        this.taxMoney = this.setThousandsMark(result.tax_money);
        this.refund_money = this.setThousandsMark(result.refund_money);
		this.labor_dispatch_money = this.setThousandsMark(result.labor_dispatch_money);
        // 消费金额
        this.usemoney = result.use_money;
      }
    },

    // 处理模态框，关闭事件
    dialogClose() {
      this.initData();
    },
    // 初始化数据
    initData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.dialogData.visible = false;
        this.dialogData.loading = true;
		this.dialogDataWarn.visible = false;
        this.isInherit = true;
        this.namePrefix = "";
        this.formData = {
          display_name: "",
        };
      });
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs["contractForm"].validate((valid) => {
        if (valid) {
          this.formSubmit();
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
    },
    //导入跳转
    importExcel() {},
    // 删除文件回调
    handleRemoveFile() {
      console.log("->删除成功....");
    },
    // 上传文件成功回调
    handUploadFile({ url, filename }) {
      console.log("->上传成功....", url, filename);
      this.formData.file_url = url;
      this.formSubmit();
    },
    async formSubmit() {
      try {
        let id = await this.$api.saveContract(this.formData);
        if (id) {
          this.$notify.success("保存成功！");
          this.mxInitUserInfo();
          this.mxRedirect("/");
        }
      } catch (err) {
        console.log("err is ->", err);
      }
    },
    // 预充值记录
    async recharges() {
      this.record = await this.$api.getrecharge();
      console.log(this.record, "00000000");
      for (let i = 0; i < this.record.length; i++) {
        this.record[i].money = this.record[i].money.toFixed(2);
      }
    },
    //获取选中日期的值
    dataSearch(payload = {}) {
      this.searchCondition = {
        day: payload.day,
        year: payload.year,
        month: payload.month,
      };
      this.getInfo();
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.day) {
        condition.day = this.searchCondition.day;
        return condition;
      }
      if (this.searchCondition.year) {
        condition.year = this.searchCondition.year;
      }
      if (this.searchCondition.month) {
        condition.month = this.searchCondition.month;
      }
      return condition;
    },
	// 判断是否是优税云
	async ysyInfo(){	
		if(this.$config.domain.ename === 'opryousuiyun') {
			this.is_ysy = true;
			let {three,list,five} = await this.$api.getWarnListData();
			this.getRecharge1(list);
			this.list_data = list;
			this.warn_300_num = three;
			this.warn_500_num = five;
			this.curveChart();
		} else {
			this.is_ysy = false;
			this.curveChart();
		}
	},
	async getRecharge1(data) {
		let myChart = this.$echarts.init(document.getElementById("chartmain1"));
		myChart.setOption({
		title: {
			text: "灵活用工个人酬劳预警图",
		},
		tooltip: {
			trigger: "axis",
			axisPointer: {
				type: "cross",
			},
		},
		// legend: {
		// 	// data: ["近7天", "近30天"],
		// 	data: ["应支付酬劳"],
		// 	right: 50,
		// },
		//数据区域缩放、滚动条
		dataZoom: [
			{
				type: "slider",
				show: true,
				xAxisIndex: [0],
				start: 1,
				end: 130,
			},
			{
				type: "inside",
				xAxisIndex: [0],
				start: 1,
				end: 130,
			},
		],
		xAxis: {
			scale: true
		},
		yAxis: {
			scale: true,
			type : 'value',
			max: 500,
			min: 0,
			axisLabel:{formatter:'{value} 万元'}
		},
		series: [
			{
				name: "应支付酬劳",
				type: "scatter",
				data: data,
			}
		],
		});
		myChart.on("legendselectchanged", function (obj) {
			// var name = obj.name;
			console.log("obj",obj)
			var option = myChart.getOption();
			// if (name == "金额") {
			// 	option.xAxis[0].data = xdata;
			// 	this.start_time = xdata[0];
			// 	this.end_time = xdata[xdata.length - 1];
			// }
			myChart.setOption(option, true);
		});
		var _this = this;
		myChart.on('click', function (params) {
			// 控制台打印数据的X轴名称
			_this.companyList = params.data[2];
			// var  str = '身份证号：'+params.data[2]+'  应支付酬劳：'+params.data[4]+'  时间：'+params.data[3];
			// _this.$message.warning(str);
			_this.dialogDataWarn.visible = true;
			_this.loadingStaus=false;
		});
	},
	async toWarnList(e){
		var _this = this;
		_this.companyList = [];
		_this.list_data.forEach(function(item){
			if(e==300&&item[0]>3) {
				_this.companyList = _this.companyList.concat(item[2])
			}
			if((e==500&&item[0]>5)) {
				_this.companyList = _this.companyList.concat(item[2])
			}
		})
		_this.dialogDataWarn.visible = true;
		_this.loadingStaus=false;
	},
  },
async  mounted() {
	await this.queryRole()
    this.getInfo();
    this.tenantCategoryList();
    this.recharges();
	this.ysyInfo();
	
	if(localStorage.getItem('user_info')){
		let obj = JSON.parse(localStorage.getItem('user_info'))
		if(obj.tenant_id == '638310559502782464'){
			this.isLaowu = true
		}
	}
  },
  computed: {
    isRootRoutePath: function () {
      return this.$route.path == "/";
    },
  },
};
</script>
<style lang="stylus" scoped>
.usemoney {
  color: #fbab5f;
  padding-bottom: 20px;
  font-size: 40px;
  margin-left: 15px;
}

.Yuchzhi {
  font-size: 14px;
  color: #333;
}

.Yuchzhi-content, .Yuchzhi-bottom {
  margin-left: 40px;
}

.record-money, .record-number {
  color: #42b1fe;
}

.record-money {
  padding-right: 5px;
  height: 14px;
  display: inline-block;
}

.record-number {
  display: inline-block;
  height: 14px;
  line-height: 14px;
  padding-left: 5px;
  border-left: 2px solid #42b1fe;
}

.record {
  padding-top: 20px;
  margin-left: 30px;
}

.home-main {
  width 100%
  display: flex;
}

.Yuchzhi {
  width: 30%;
  //flex 1
  height: 500px;
  padding: 20px;
  margin-top: 20px;
  border-radius: 25px;
  margin-left: 3%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.first-price-span {
  color: #FBAB5F;
  text-align: center;
  font-size: 60px;
}

.first-price-item {
  font-size: 40px;
  margin-top: 80px;
  margin-bottom: 50px;
  color: #333;
}

.price-item-wrapper {
  width: 70%;
  margin: 0 auto;
}

.price-left, .price-right {
  border: 1px solid rgba(223, 223, 223, 1);
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.price-left {
  border-right: none;
}

.recharge-wrapper {
  border: 1px solid rgba(223, 223, 223, 1);
  padding-left: 40px;
  display: flex;
  align-items: center;
  margin-top: 40px;
  height: 80px;
}

.recharge-wrapper {
  border-bottom: none;
}

.recharge {
  height: 40px;
  border-left: 7px solid #42B1FE;
  line-height: 40px;
  font-size: 25px;
  color: rgba(66, 177, 254, 1);
  padding-left: 20px;
}

.price-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  margin: 0 auto;
  height: 450px;
  margin-top: -20px;
}

.calculation-price {
  border-radius: 10px;
  width: 50%;
}

.calculation {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-right: 40px;
  margin: 10px 0;
}

.calculate {
  width: 80px;
  text-align: center;
  font-size: 18px;
  height: 40px;
  line-height: 40px;
  background-color: #ff9b21;
  background-image: linear-gradient(to right, #ff9b21, #ff8030);
  border-radius: 5px;
  margin-left: 5px;
  color: #fff;
}

.calculate:hover {
  cursor: pointer;
}

.price-item {
  font-size: 20px;
  padding: 5px;
  color: #333;
}

.price-span {
  color: #67757c;
}

.el-container {
  background: #f0f2f5;
}

.el-aside {
  min-height: 100vh;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
  position: relative;
  width: auto !important;
  z-index: 10;
  transitionall: 0.3s;
  background: #2c343f;
}

.el-header {
  height: 64px !important;
  padding: 0px;
  width: 100%;
}

.el-main {
  padding: 0px;
  overflow: inherit;
  flexnone: @css !important;
  min-height: 720px;
}

.main-page-content {
  border-radius: 5px;
  background: #ffffff;
  padding: 24px;
}

.el-footer {
  height: auto !important;
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 60px;
  font-size: 24px;
  background: #F7F8FA;
}

.info-title, .info-price {
  padding: 5px;
}

.info-title {
  color: #333;
}

.info-img {
  width: 40px;
  height: 40px;
  padding: 10px;
  background-color: rgba(241, 244, 249, 100);
  border-radius: 50%;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.page-header {
  background: #fff;
  padding: 16px 32px 0 32px;
  border-bottom: 1px solid #e8e8e8;
}

.page-content {
  margin: 0 auto;
}

.main-page-content {
  min-height: 600px;
}

.agree-header {
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: rgba(255, 149, 2, 1);
  margin-top: 20px;
  font-size: 100px;
}

.agree-title {
  width: 978px;
  background-color: rgba(255, 255, 255, 0);
  color: rgba(166, 23, 23, 1);
  font-size: 18px;
  text-align: center;
  font-family: Roboto;
  margin: 0 auto;
}

.go-to {
  position: absolute;
  bottom: 100px;
  right: 100px;
}

.warn-title {
  width: 1143px;
  height: 50px;
  line-height: 50px;
  margin: 0 auto;
  border-radius: 5px 5px 5px 5px;
  background-color: rgba(82, 80, 80, 1);
  color: #fff;
  font-size: 20px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(187, 187, 187, 1);
}

.table-header {
  margin-bottom: 12px;
}

.contact-upload {
  padding-top: 50px;
  width: 980px;
  margin: 0 auto;
}

.mod-index {
  border-radius: 5px;
  background: #fff;
  padding: 24px;
  min-height: 800px;
  line-height: 1.5;

  p {
    margin: 0;
  }

  h3 {
    margin-block-start: 0;
    margin-block-end: 0.5em;
  }

  .xm-gt img {
    height: 240px;
    margin-left: -16px;
  }

  .jx-zz img {
    height: 400px;
    margin-top: 24px;
    margin-right: 24px;
  }
}

.el-container {
  background: #f0f2f5;
}

.el-aside {
  min-height: 100vh;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
  position: relative;
  width: auto !important;
  z-index: 10;
  transitionall: 0.3s;
  background: #2c343f;
}

.el-header {
  height: 64px !important;
  padding: 0px;
  width: 100%;
}

.el-main {
  padding: 0px;
  margin: 24px;
  overflow: inherit;
  flexnone: @css { !important };
  min-height: 720px;
}

.main-page-content {
  border-radius: 5px;
  background: #ffffff;
  padding: 24px;
}

.el-footer {
  height: auto !important;
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  font-size: 20px;
  background: #F7F8FA;
}

.info-title, .info-price {
  padding: 5px;
}

.info-title {
  color: #333;
  display: flex;
  align-items: center;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 5px;
  height: 120px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.check-box {
  padding: 10px 0;
}

.upgrade-title/deep/.el-dialog__title {
  display: flex;
  justify-content: center;
}

.dialog-footer {
  display: flex;
  justify-content: center;
}

/deep/.info-title .el-icon-warning {
  font-size: 25px;
  color: #e6a23c;
  margin-left: 10px;
}
</style>


